define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Button = require("ui/button/Button");
    var Logger = require("logger");
    var LinkModel = require("ui/link/js/models/Link");
    var template = require("ui/link/templates/link.tmpl");
    var _ = require("underscore");
    var $ = require("jquery");

    var linkView = Marionette.ItemView.extend({
        tagName: "div",
        ui: {
            actionBtn: ".actionBtn"
        },

        initialize: function (options) {
            this.logger = Logger.getLogger("Link");
            if (!this._isValidOptions(options)) {
                throw "Link :: invalid argument: options is illegal.";
            }

            this.$el = options.el ;
            this.permutation = options.permutation || linkView.PERMUTATION.DEFAULT;
            this.template = template;
            this.href = options.href;
            this.tabindex = options.tabindex;
            this.text=  options.text || this.$el.text();
            this.tooltip = options.tooltip || "";

            this.model = new LinkModel(options);

        },

        onRender: function () {
            var permutationClass=this._getPermutationClass();
            if(permutationClass){
                this.$el.addClass(permutationClass);
            }
            $(this.$el).append(this.el);
        },


        _isValidOptions: function (options) {
            if (!options || !_.isObject(options)) {
                this.logger.error("invalid argument: options is illegal");
                this.logger.graph({ name: "UIComponents:LinkInValidOptions"});
                return false;
            }
            if (!options.el ) {
                this.logger.error("invalid argument: options.el is illegal");
                this.logger.graph({ name: "UIComponents:LinkInValidOptions"});
                return false;
            }
            if (!options.href ) {
                this.logger.error("invalid argument: options.href is illegal");
                this.logger.graph({ name: "UIComponents:LinkInValidOptions"});
                return false;
            }
            if (!options.text  && !this.$el.text() ) {
                this.logger.error("invalid argument: options.text is illegal");
                this.logger.graph({ name: "UIComponents:LinkInValidOptions"});
                return false;
            }

            return true;
        },

        _getPermutationClass: function (){
            var retClass = "";
            switch (this.permutation) {
                default:
                    retClass = "";
                    break;

            }
            return retClass;
        }


    });

    linkView.PERMUTATION = {
        DEFAULT:1

    };

    return linkView;
});
